import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { SelectMessage as SelectMessageType } from "@/types/agent/message";
import { SpeechBubble } from "./SpeechBubble";
interface SelectMessageProps {
  message: SelectMessageType;
}
export const SelectMessage: React.FC<SelectMessageProps> = t0 => {
  const $ = _c(23);
  const {
    message
  } = t0;
  const [isSelected, setIsSelected] = useState(message.isSelected);
  const [selectedValue, setSelectedValue] = useState(message.selectedValue);
  let t1;
  if ($[0] !== message) {
    t1 = option => {
      setIsSelected(true);
      setSelectedValue(option.value);
      message.update?.({
        isSelected: true,
        selectedValue: option.value
      } as Partial<SelectMessageType>);
      message.onSelect?.(option.text);
    };
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSelect = t1;
  if (isSelected) {
    let t2;
    if ($[2] !== message.options || $[3] !== selectedValue) {
      let t3;
      if ($[5] !== selectedValue) {
        t3 = opt => opt.value === selectedValue;
        $[5] = selectedValue;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      t2 = message.options.find(t3);
      $[2] = message.options;
      $[3] = selectedValue;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    const selectedOption = t2;
    const t3 = selectedOption?.text;
    let t4;
    if ($[7] !== t3) {
      t4 = <SpeechBubble sender="assistant"><p className="text-sm font-medium whitespace-nowrap">✓ {t3}</p></SpeechBubble>;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  const t2 = message.title;
  let t3;
  if ($[9] !== message.title) {
    t3 = <p className="font-bold text-base px-1">{message.title}</p>;
    $[9] = message.title;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== message.description) {
    t4 = message.description && <p className="text-sm text-black/70 px-1">{message.description}</p>;
    $[11] = message.description;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleSelect || $[14] !== message.options) {
    let t6;
    if ($[16] !== handleSelect) {
      t6 = option_0 => <button key={option_0.value} type="button" onClick={() => handleSelect(option_0)} className="w-full px-4 py-2 bg-yellow text-black rounded-full font-bold hover:bg-yellow/80 transition-colors text-left text-sm cursor-pointer">{option_0.text}</button>;
      $[16] = handleSelect;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    t5 = message.options.map(t6);
    $[13] = handleSelect;
    $[14] = message.options;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[18] !== message.title || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <SpeechBubble sender="assistant" className="flex flex-col gap-2 min-w-[280px]" role="group" aria-label={t2}>{t3}{t4}{t5}</SpeechBubble>;
    $[18] = message.title;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};